const TaxonomyNames = {
    make: 'make',
    body: 'body',
    color: 'color',
    condition: 'condition',
    transmission: 'transmission',
    fuel_type: 'fuel_type',
    number_of_door: 'number_of_door',
    drive: 'drive',
    holding_period: 'holding_period',
    distance_from_me: 'distance_from_me',
    price_range: 'price_range',
};

export default TaxonomyNames
